import script from "./OkrElementBulkCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./OkrElementBulkCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./OkrElementBulkCheckbox.vue?vue&type=style&index=0&id=4eea0e29&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eea0e29"]])

export default __exports__